require("component-responsive-frame/child");
require("./map");